/**
 * Enum for user role identifiers.
 * STAFF, MEMBER, CORRESPONDENT, or GUEST.
 */
export enum UserRoleIdent {
  STAFF = 'STAFF',
  MEMBER = 'MEMBER',
  CORRESPONDENT = 'CORRESPONDENT',
  GUEST = 'GUEST',
}

export type UserDetails = {
  role?: UserRoleIdent;
  userAnonymisedId?: string | undefined;
  companyName?: string | null;
  jobTitle?: string | null;
};
